import store from '@/store'
import { get } from 'lodash-es'
import { modelStateRegistry } from '@/utils/modelStateRegistry'
import { getArnCategoriesColumnGroups } from './arnCategoriesColumnGroups'
import { buildArnCategoriesColumnDef } from './arnCategoriesColumnsDef'
import {
  formatConstructedError,
  defaultResultKey,
  defaultChemicalKey,
  defaultResultsKey,
} from '@/utils/responseNormalizers'
import { createMetadataHelpers } from '../metadata'

const groupedKeys = get(modelStateRegistry, 'groupedModel.keys')
const namespace = 'arnCategories'

const { getName, getDescription, getEndpointIds } = createMetadataHelpers(`${namespace}/${groupedKeys.getMetadata}`)

const getArnAdapter = (modelId) => ({
  [modelId]: {
    chemicalKey: defaultChemicalKey,
    predictionsKey: defaultResultKey,
    errorKey: 'error',
    categoryId: 'categorizationModels',
    formatError: (error) => formatConstructedError(error),
    getResults: () => store.getters[`${namespace}/${groupedKeys.getResultsForModel}`](modelId)?.[defaultResultsKey],
    getIsLoading: () => store.getters[`${namespace}/${groupedKeys.getIsLoadingForModel}`](modelId),
    getIsAborted: () => store.getters[`${namespace}/${groupedKeys.getIsAbortedForModel}`](modelId),
    fetch: (chemicals) => store.dispatch('arnCategories/predict', { structures: chemicals, modelId }),
    reset: () => store.commit(`${namespace}/${groupedKeys.RESET_STATE_FOR_MODEL}`, modelId),
    abort: () => store.commit(`${namespace}/${groupedKeys.ABORT_CURRENT_FETCH_FOR_MODEL}`, { modelId }),
    getParameters: getArnCategoriesColumnGroups,
    getColumnDefBuilder: buildArnCategoriesColumnDef,
    getName: () => getName(modelId),
    getDescription: () => getDescription(modelId),
  },
})

const getArnAdapters = () => getEndpointIds().reduce((acc, modelId) => ({ ...acc, ...getArnAdapter(modelId) }), {})

export { getArnAdapters }
